<template>
  <!--
    Wyświetla sekcję filtrów dla wybranych znaków (signs) z store.filters.signs.
    Cały komponent renderowany tylko, gdy istnieje co najmniej jeden element w store.filters.signs.
  -->
  <div v-if="store.filters.signs" class="filter d-flex flex-column">
    <!--
      Nagłówek sekcji:
      - h-sign: etykieta kolumny dla łańcucha znaków
      - h-status: etykieta kolumny dla statusu
      - ikona kosza do usunięcia wszystkich filtrów znaków
    -->
    <h5 class="margin-0">
      <span class="h-sign">{{ t('sign') }}</span>
      <span class="h-status">{{ t('status') }}</span>
      <!-- Kliknięcie usuwa filtr "signs" -->
      <span class="icon-trash" @click="removeFilter()" role="button"></span>
    </h5>

    <!--
      Iteracja po każdym obiekcie "sign" w tablicy store.filters.signs.
      Dla każdego elementu generowany jest wiersz z nazwą i ikoną statusu.
    -->
    <div
      v-for="(sign, key) in store.filters.signs"
      :key="key"
      class="collapse show"
      id="signs"
    >
      <!-- Wiersz informacyjny: nazwa i status -->
      <div class="info collapse show">
        <!-- Wyświetlenie parametrów chainage (położenie) -->
        <div class="name">
          {{ sign.chainage }}
        </div>
        <!--
          Blok obrazka reprezentujący status:
          - Klasy dynamiczne zwracane przez mapStatus:
            * icons-status-ok
            * icons-status-not-ok
            * icons-status-error
        -->
        <div
          :class="
            'img-fluid fitted-image col-4 ' +
            mapStatus(sign.status, sign.statusDesc)
          "
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignsFilterView", // Nazwa komponentu dla Vue DevTools

  props: {
    // Store Pinia zawierający filtr "signs" oraz metody do jego modyfikacji
    store: { required: true },
  },

  methods: {
    /**
     * Usuwa wszystkie filtry znaków (klucz "signs")
     */
    removeFilter() {
      this.store.removeItem("signs");
    },

    /**
     * Mapuje stan dostępności znaku na klasę CSS ikony:
     * @param {boolean} available - true jeśli znak dostępny
     * @param {string} statusDesc - opis statusu (może zawierać komunikat błędu)
     * @returns {string} - odpowiednia klasa CSS do wyświetlenia ikony statusu
     */
    mapStatus(available, statusDesc) {
      if (available) {
        // Dostępne: ikona OK
        return "icons-status-ok";
      } else {
        // Niedostępne: rozróżniamy przyczynę
        if (statusDesc.startsWith("Failed to ")) {
          // Nieudanego sprawdzenia: ikona NOT-OK
          return "icons-status-not-ok";
        } else if (statusDesc.startsWith("Unavailable")) {
          // Brak zasobu: ikona ERROR
          return "icons-status-error";
        }
      }
      // Domyślnie traktujemy jako błąd
      return "icons-status-error";
    },
  },
};
</script>

<style scoped>
/* Główny kontener filtra: pełna szerokość */
.filter {
  width: 100%;
}

/* Styl nagłówka (h5): wyświetla nazwy kolumn i przycisk kasowania */
.filter h5 {
  margin: 0;
  padding: var(--spacing-md) var(--spacing-lg);
  position: relative;
  background: var(--surface-secondary);
  border-bottom: 1px solid var(--border-default);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-caps);
  text-transform: uppercase;
  color: var(--text-primary);
}

/* Klasa h-sign: kolumna z nazwą znaku */
.filter h5 .h-sign {
  width: 120px;
}

/* Klasa h-status: kolumna ze statusem, wyśrodkowany tekst */
.filter h5 .h-status {
  width: 60px;
  text-align: center;
}

/* Wiersz info: flex do wyświetlania nazwy i ikony */
.info {
  display: flex;
  font-size: var(--font-size-sm);
  padding: var(--spacing-md) var(--spacing-lg);
  border-bottom: 1px solid var(--border-default);
}

/* Styl nazwy (chainage): stała szerokość i obramowanie po prawej */
.info .name {
  display: flex;
  width: 120px;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid var(--border-default);
}

/* Klasa img-fluid: kontener ikony statusu */
.info .img-fluid {
  height: 27px;
  width: 60px;
}

/* Ikona kosza: pozycjonowanie w prawym górnym rogu nagłówka */
.icon-trash {
  background: url("../../assets/icons/trash.svg") no-repeat left top;
  width: 15px;
  height: 17px;
  position: absolute;
  cursor: pointer;
  top: 8px;
  right: 10px;
}
</style>